import {
  instance as axios,
  setJwtToken,
} from "../../config/axiosInstance";


// ------------promoCode-list-Api-------------------
export const promoCodeListApi = async (data) => {
  const endPoint = `/admin/coupon?${new URLSearchParams(data).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};

// ------------promoCode-Detail-Api-------------------
export const getPromoCodeDetailApi = async ({ id }) => {
  const endPoint = `/admin/coupon/${id}`;
  return await axios.get(endPoint, setJwtToken());
  
};

export const editPromoCodeApi = async ({id}, data) => {
  const endPoint = `/admin/coupon/${id}`;
  return await axios.put(endPoint, data, setJwtToken());
};

// ------------promoCode-change-status-Api-------------------
export const promoCodeChangeStatusApi = async ({ id, status }) => {
  const endPoint = `/admin/coupon/${id}`;
  return await axios.patch(endPoint, { status }, setJwtToken());
};
// -----------add-promoCode-Api-------------------
export const addPromoCodeApi = async (data) => {
  const endPoint = `/admin/coupon`;
  return await axios.post(endPoint, data, setJwtToken());
};
// ------------promoCode-delete-Api-------------------
export const deletePromoCodeApi = async (id) => {
  const endPoint = `/admin/coupon/${id}`;
  return await axios.delete(endPoint, setJwtToken());
};